import React from 'react';
import styled from 'styled-components';
import Button from '../../common/Button.js';
import { Link } from 'react-router-dom';

const HeroSection = styled.section`
  height: 100vh;
  position: relative;
  display: flex;
  align-items: center;
  text-align: center;
  color: white;
  overflow: hidden;
  padding-top: var(--header-height); /* Add padding for header height */
  
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-image: url('/images/hero.png');
    background-size: cover; /* Changed to cover for better mobile display */
    background-position: center center; /* Better positioning */
    background-repeat: no-repeat;
    filter: brightness(0.7);
    z-index: -1;
  }
  
  @media (max-width: 768px) {
    padding-top: var(--mobile-header-height); /* Adjust padding for mobile header */
  }
`;

const HeroContent = styled.div`
  max-width: 800px;
  margin: 0 auto;
  padding: 0 1rem;
  
  h1 {
    font-size: 3.5rem;
    margin-bottom: 1.5rem;
  }
  
  p {
    font-size: 1.25rem;
    margin-bottom: 2rem;
    opacity: 0.9;
  }
  
  .buttons {
    display: flex;
    gap: 1rem;
    justify-content: center;
    margin-top: 10px; /* Added 10px of space before the buttons */
  }
  
  @media (max-width: 768px) {
    h1 {
      font-size: 2.5rem;
    }
    
    p {
      font-size: 1rem;
    }
    
    .buttons {
      flex-direction: column;
      gap: 0.5rem;
    }
  }
`;

const Hero = () => {
  return (
    <HeroSection>
      <HeroContent>
        <h1>Building Quality Homes in the NC Triad Area</h1>
        <p>Shoffner Homes is a premier residential home building construction company specializing in quality craftsmanship, custom builds, and exceptional client experiences.</p>
        <div className="buttons">
          <Button as={Link} to="/homes-for-sale" variant="secondary" size="large">View Homes For Sale</Button>
          <Button 
            as={Link} 
            to="/contact" 
            variant="outline" 
            size="large"
            style={{ 
              color: 'white', 
              borderColor: 'white', 
              borderWidth: '3px',
              textShadow: '0 1px 3px rgba(0,0,0,0.5)'
            }}
          >
            Contact Us
          </Button>
        </div>
      </HeroContent>
    </HeroSection>
  );
};

export default Hero;